import React from 'react';
import { PaystackButton } from 'react-paystack';
import { X } from 'lucide-react';

const MockPayment = ({ isOpen, onClose, amount, onSuccess, title = "Complete Payment" }) => {
    if (!isOpen) return null;

    const publicKey = import.meta.env.VITE_PAYSTACK_PUBLIC_KEY || 'pk_test_d3a3eb1a92e620575d27d7807c4d5218d2d6c1be';
    
    const componentProps = {
        email: "diaspora_user@eznaija.com",
        amount: amount * 100, // Paystack expects amount in Kobo
        metadata: {
            name: "Ez Naija Client",
            phone: "08012345678",
        },
        publicKey,
        text: "Pay Securely with Paystack",
        onSuccess: (response) => {
            console.log("Paystack response:", response);
            onSuccess();
            onClose();
        },
        onClose: () => {
            console.log("Paystack modal closed");
            onClose();
        },
    };

    return (
        <div className="payment-overlay">
            <div className="payment-modal animate-fade">
                <div className="payment-header">
                    <h3>{title}</h3>
                    <button onClick={onClose} className="close-btn"><X size={20} /></button>
                </div>
                <div className="payment-body">
                    <p style={{ textAlign: 'center', marginBottom: '20px', color: 'var(--text-light)' }}>
                        You are paying via Escrow. Ez Naija secures your funds and releases them to the provider only after successful service delivery.
                    </p>
                    <div className="amount-display">
                        <span className="currency">₦</span>
                        <span className="value">{amount.toLocaleString()}</span>
                    </div>

                    <PaystackButton 
                        {...componentProps} 
                        className="primary-btn full-width" 
                        style={{ marginTop: '20px', background: '#09A5DB' }} // Paystack Blue
                    />
                </div>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
        .payment-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: flex-end;
          justify-content: center;
          z-index: 2000;
        }
        .payment-modal {
          background: white;
          width: 100%;
          max-width: 480px;
          border-radius: 20px 20px 0 0;
          padding: 24px;
          padding-bottom: 40px;
        }
        .payment-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
        }
        .close-btn { background: none; color: var(--text-light); }
        .amount-display {
          display: flex;
          align-items: baseline;
          justify-content: center;
          gap: 4px;
          margin-bottom: 30px;
        }
        .amount-display .currency { font-size: 24px; font-weight: 600; }
        .amount-display .value { font-size: 48px; font-weight: 800; }
        
        .full-width { width: 100%; margin-top: 10px; }
      `}} />
        </div>
    );
};

export default MockPayment;
